export enum CourseTypeEnum {
  LiveSessions,
  Recorded,
  OnSite,
  Compact
}
